/**
 * Post Task Banner
 *
 * CTA banner with image on the right:
 * - Heading and description on the left
 * - "Post a Task" button
 * - Professional image on the right
 */

'use client';

import { useTranslations } from 'next-intl';
import { Typography } from '@/src/shared/ui/typography/Typography';
import { PrimaryButton } from '@/src/shared/ui/button/PrimaryButton';
import { useNavigation } from '@/src/shared/lib/hooks/use-navigation';

export function PostTaskBanner() {
  const t = useTranslations('landing.postTaskBanner');
  const { handlePostTask } = useNavigation();

  return (
    <section className="container-auto">      
        <div className="w-full bg-gradient-to-r from-[#F5F5DC] via-[#E8F5E9] to-[#C8E6C9] rounded-3xl overflow-hidden">
          {/* Mobile: Image top, Text bottom | Tablet+: Text left, Image right */}
          <div className="flex flex-col-reverse md:flex-row items-stretch min-h-[500px]">
            {/* Left Content - 100% mobile, 45% tablet+ */}
            <div className="flex-[0_0_100%] md:flex-[0_0_45%] flex items-center justify-center p-8 md:p-12 lg:p-16">
              <div className="space-y-6 md:space-y-8 max-w-lg text-center md:text-left">
                <Typography
                  variant="h1"
                  weight="bold"
                  className="text-[#2A2A0F] leading-tight"
                >
                  {t('title')}
                </Typography>

                <Typography
                  variant="body"
                  className="text-[#2A2A0F] leading-relaxed"
                >
                  {t('description')}
                </Typography>

                <div className="flex justify-center md:justify-start">
                  <PrimaryButton
                    onClick={handlePostTask}
                    className="rounded-btn-pill px-12 py-4 bg-accent-primary hover:bg-accent-hover active:bg-accent-active transition-colors"
                  >
                    <Typography variant="h3" color="inherit" weight="semibold">
                      {t('button')}
                    </Typography>
                  </PrimaryButton>
                </div>
              </div>
            </div>

            {/* Right Image - 100% mobile, 55% tablet+ */}
            <div className="flex-[0_0_100%] md:flex-[0_0_55%] relative">
              <div className="relative h-[300px] md:h-full w-full">
                <img
                  src="/images/banners/post_task.png"
                  alt={t('imageAlt')}
                  className="w-full h-full object-cover rounded-t-3xl md:rounded-none md:rounded-r-3xl"
                />
              </div>
            </div>
          </div>
        </div>      
    </section>
  ); 
}
